import { render } from "./ClientLeads.vue?vue&type=template&id=565e55e1"
import script from "./ClientLeads.vue?vue&type=script&lang=js"
export * from "./ClientLeads.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__